var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.104,
    height: 42.601,
    viewBox: "0 0 39.104 42.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_323",
    x: 0,
    y: 0,
    width: 39.104,
    height: 42.601,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#51b4d2",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_324",
    x: 12.308,
    y: 4.108,
    width: 14.474,
    height: 17.969,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#51b4d2",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_239",
    "data-name": "Groupe 239",
    transform: "translate(784.835 1367.438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -784.83, -1367.44)",
    filter: "url(#Trac\\xE9_323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_323-2",
    "data-name": "Trac\\xE9 323",
    d: "M-780.335-1337.814v-2.645a3.29,3.29,0,0,1,.671-1.412,2.829,2.829,0,0,1,2.043-.953v-12.3c-.619,0-1.216-.015-1.811.005a.855.855,0,0,1-.9-.5v-3.115a2.5,2.5,0,0,1,.441-.447q5.783-3.452,11.58-6.881a9.435,9.435,0,0,1,2.673-1.371h.764a6.962,6.962,0,0,1,.966.4q6.631,3.92,13.252,7.859a.785.785,0,0,1,.42.746c-.009.715-.027,1.431,0,2.144.044,1.07-.295,1.2-1.165,1.169-.515-.019-1.031,0-1.556,0v12.3c.06.007.1.013.137.016a2.655,2.655,0,0,1,2.522,2.3,18.439,18.439,0,0,1,.055,2.228c.007.735-.206.942-.94.942q-14.1,0-28.2.007A.957.957,0,0,1-780.335-1337.814Zm1.364-18.7H-751.6c0-.444-.016-.873.006-1.3a.49.49,0,0,0-.282-.51q-6.3-3.73-12.594-7.478a1.448,1.448,0,0,0-1.624,0c-1.844,1.11-3.7,2.2-5.55,3.3q-3.545,2.107-7.088,4.218c-.091.055-.22.151-.223.232C-778.981-1357.548-778.971-1357.041-778.971-1356.516Zm.029,17.792H-751.6c0-.387,0-.757,0-1.126a1.415,1.415,0,0,0-1.61-1.6h-24.149c-.1,0-.2,0-.294,0a1.311,1.311,0,0,0-1.273,1.132A14.618,14.618,0,0,0-778.941-1338.724Zm6.844-16.383v12.279h4.056v-12.279Zm9.563,0v12.279h4.066v-12.279Zm-13.671-.007v12.284h2.681v-12.284Zm9.578,0v12.283h2.678v-12.283Zm12.266.007h-2.692v12.278h2.692Z",
    transform: "translate(784.83 1367.44)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -784.83, -1367.44)",
    filter: "url(#Trac\\xE9_324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_324-2",
    "data-name": "Trac\\xE9 324",
    d: "M-633.643-1319.383a2.73,2.73,0,0,1,2.748,2.734,2.746,2.746,0,0,1-2.724,2.735,2.751,2.751,0,0,1-2.75-2.74A2.737,2.737,0,0,1-633.643-1319.383Zm-1.35,2.742a1.365,1.365,0,0,0,1.366,1.36,1.367,1.367,0,0,0,1.359-1.368,1.364,1.364,0,0,0-1.381-1.373A1.365,1.365,0,0,0-634.992-1316.641Z",
    transform: "translate(653.18 1323.49)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBlue);
export default __webpack_public_path__ + "static/media/bank-blue.07f701a57022b64e17ae4da00cf7fcb9.svg";
export { ForwardRef as ReactComponent };